import { gql } from "@apollo/client";

const SidebarQuery_Emerson_Query = gql`
  query SidebarQuery_Emerson_Query {
    currentPractitioner {
      id
      firstName
      lastName
      hasMultipleStorePlatforms
      avatar {
        id
        photoUrl(filter: SMALL_SIZE)
      }
    }
  }
`;

export { SidebarQuery_Emerson_Query };
